import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import images from "../../assets/images";
import Modal from "../../components/modal/Modal";
import { ArrowLeft } from "lucide-react";
import { usePremisesStore } from "../../store/store";
import axiosInstance from "../../common/axiosInstance";

const PremisesModules: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkboxState, setCheckboxState] = useState<string[]>([]);
  const { id } = useParams<{ id: any }>();
  const { setPremisesModules, handelSubmitPremises, updatePremise } =
    usePremisesStore();
  const location = useLocation();
  const path = location.pathname.split("/");
  const isView = path[1] === "view-premises" ? true : false;
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    const getPremisesById = async () => {
      const response: any = await axiosInstance.get(`/api/premises/${id}`);
      setCheckboxState(response.data.premisesModules);
    };
    if (id) {
      getPremisesById();
    }
  }, [id]);

  const FireSuppression = [
    { image: images.deyRisers, text: "Dry Risers" },
    { image: images.fireExtinguisher, text: "Fire Extinguisher & Blankets" },
    { image: images.firefighting, text: "Fire Fighting Lifts" },
    { image: images.gasSuppression, text: "Gas Suppression System" },
    { image: images.reeksHydrants, text: "Hose Reels & Hydrants" },
    { image: images.kitchenSuppression, text: "Kitchen Suppression System" },
    { image: images.sprinklerSystem, text: "Sprinkler System" },
    { image: images.mistSystem, text: "Water Mist System" },
  ];

  const MeansOfEscape = [
    { text: "Emergency Lighting", image: images.emergencyLight },
    { text: "Evac Alert System", image: images.evacAlert },
    { text: "EVCS", image: images.evac },
    { text: "Fire Shutters & Curtains", image: images.fireShutter },
    { text: "Full Building Evacuation", image: images.buildingEvacuation },
    { text: "Smoke Control System", image: images.smokeControl },
  ];

  const handleCheckboxChange = (text: string) => {
    setCheckboxState((prev) =>
      prev.includes(text) ? prev.filter((i) => i !== text) : [...prev, text]
    );
  };

  const handleSubmit = () => {
    setPremisesModules(checkboxState);
    id ? updatePremise(id) : handelSubmitPremises();
    openModal();
  };

  return (
    <>
      <div className="flex w-full mt-16 flex-col mb-2 justify-start px-3 items-start">
        <div className="w-full flex justify-between items-center mr-4 pb-2">
          <h1>
            {isView === true
              ? "View Premises"
              : id
              ? "Update Premises"
              : "Add Premises"}
          </h1>
          <div className="flex w-1/2 items-center justify-between">
            <span>
              Admin: <strong> Bhanu prasad</strong>
            </span>
            <div>
              <span>
                Create Date: <strong> 09/01-2025</strong>
              </span>
            </div>
            <div>
              <Link to="/premises" data-discover="true">
                <button className="flex items-center px-3 py-2 bg-[#61748e] text-white rounded-full">
                  <ArrowLeft />
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="w-[98%] bg-gray-200 rounded-full h-2.5 mx-2">
          <div
            className="bg-[#0fa9a6] h-2.5 rounded-full"
            style={{ width: `100%` }}
          ></div>
        </div>
        <div className="w-full h-full pt-4 drop-shadow-lg mr-4 rounded-t-lg bg-white flex-col">
          <form className="w-full overflow-auto px-4 h-[350px]">
            <div className="w-full gap-5">
              <div className="w-full">
                <div className="w-full my-2 pl-3">
                  <span className="text-[18px] font-semibold">
                    Risk Assessment and Training
                  </span>
                  <div className="w-full gap-3 mt-2 flex">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        className="mr-2"
                        disabled={isView === true}
                        checked={checkboxState.includes("Fire Risk Assignment")}
                        onChange={() =>
                          handleCheckboxChange("Fire Risk Assignment")
                        }
                      />
                      <img
                        src={images.apFirsRisk}
                        className="w-6 mr-2"
                        alt=""
                      />
                      <span className="font-medium">Fire Risk Assignment</span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        className="mr-2"
                        disabled={isView === true}
                        checked={checkboxState.includes("Training")}
                        onChange={() => handleCheckboxChange("Training")}
                      />
                      <img
                        src={images.apTraining}
                        alt=""
                        className="w-7 mr-2"
                      />
                      <span className="font-medium">Training</span>
                    </div>
                  </div>
                </div>
                <div className="w-full bg-[#f0f8ff] py-2 pl-3">
                  <div className="mt-2">
                    <span className="text-[18px] font-semibold">
                      Fire Detection Alarm (Part 1)
                    </span>
                  </div>
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      className="mr-2"
                      disabled={isView === true}
                      checked={checkboxState.includes(
                        "Fire Detection & Alarm (Part 1)"
                      )}
                      onChange={() =>
                        handleCheckboxChange("Fire Detection & Alarm (Part 1)")
                      }
                    />
                    <img src={images.apFireAlarm} alt="" className="w-7 mr-2" />
                    <span className="font-medium">
                      Fire Detection &amp; Alarm (Part 1)
                    </span>
                  </div>
                </div>
                <div className="w-full py-3 pl-3">
                  <span className="text-[18px] font-semibold">
                    Domestic Detection (Part 6)
                  </span>
                  <div className="mt-2 grid grid-cols-3 w-full">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        className="mr-2"
                        disabled={isView === true}
                        checked={checkboxState.includes(
                          "Carbon Monoxide Domestic (Part 6)"
                        )}
                        onChange={() =>
                          handleCheckboxChange(
                            "Carbon Monoxide Domestic (Part 6)"
                          )
                        }
                      />
                      <img
                        src={images.apDetectionIcon}
                        className="w-7 mr-2"
                        alt=""
                      />
                      <span className="font-medium">
                        Carbon Monoxide Domestic (Part 6)
                      </span>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        className="mr-2"
                        disabled={isView === true}
                        checked={checkboxState.includes(
                          "Fire Detection Domestic (Part 6)"
                        )}
                        onChange={() =>
                          handleCheckboxChange(
                            "Fire Detection Domestic (Part 6)"
                          )
                        }
                      />
                      <img
                        src={images.apDetectionIcon}
                        className="w-7 mr-2"
                        alt=""
                      />
                      <span className="font-medium">
                        Fire Detection Domestic (Part 6)
                      </span>
                    </div>
                  </div>
                </div>
                <div className="w-full bg-[#f0f8ff] py-3 pl-3">
                  <div className="mt-2">
                    <span className="text-[18px] font-semibold">
                      Fire Suppression
                    </span>
                  </div>
                  <div className="mt-2 grid grid-rows-3 grid-cols-3 w-full gap-3">
                    {FireSuppression.map((value, index) => (
                      <div key={index} className="flex items-center">
                        <input
                          type="checkbox"
                          className="mr-2"
                          disabled={isView === true}
                          checked={checkboxState.includes(value.text)}
                          onChange={() => handleCheckboxChange(value.text)}
                        />
                        <img src={value.image} alt="img" className="w-7 mr-2" />
                        <span className="font-medium">{value.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="w-full my-2 pl-3">
                  <div className="mt-2">
                    <span className="text-[18px] font-semibold">
                      Means Of Escape
                    </span>
                  </div>
                  <div className="mt-2 grid grid-cols-3 w-full gap-3">
                    {MeansOfEscape.map((value, index) => (
                      <div key={index} className="flex mt-2">
                        <input
                          type="checkbox"
                          className="mr-2"
                          disabled={isView === true}
                          checked={checkboxState.includes(value.text)}
                          onChange={() => handleCheckboxChange(value.text)}
                        />
                        <img src={value.image} alt="img" className="w-7 mr-2" />
                        <span className="font-medium">{value.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="w-full mt-7 flex justify-end items-center h-18 p-2 bg-[#61748e]">
            <Link
              className="text-white mr-2"
              to={
                isView
                  ? `/view-premises/modules/${id}`
                  : id
                  ? `/update-premises/modules/${id}`
                  : "/add-premises/modules/"
              }
              data-discover="true"
            >
              <button className="h-10 bg-[#869ab6] text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0">
                Previous
              </button>
            </Link>
            {isView === true ? (
              <Link className="text-white" to="/premises" data-discover="true">
                <button className="h-10 bg-[#0fa9a6] text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0">
                  Back
                </button>
              </Link>
            ) : id ? (
              <Link
                className="text-white"
                to=""
                onClick={handleSubmit}
                data-discover="true"
              >
                <button className="h-10 bg-[#0fa9a6] text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0">
                  update
                </button>
              </Link>
            ) : (
              <Link
                className="text-white"
                to=""
                onClick={handleSubmit}
                data-discover="true"
              >
                <button className="h-10 bg-[#0fa9a6] text-lg px-5 py-1 rounded-full bottom-0 left-0 right-0">
                  Submit
                </button>
              </Link>
            )}
          </div>
          <Modal isOpen={isModalOpen} onClose={closeModal}>
            <div className="bg-white w-[400px] rounded-xl flex flex-col justify-center items-center text-center h-full p-3">
              <img src={images.CheckMark} alt="img" className="w-16" />
              <h4>Successfully updated premises and fire safety details</h4>
              <Link to="/premises">
                <button className="px-3 bg-[#0fa9a6] text-white text-lg rounded-full py-1">
                  Continue
                </button>
              </Link>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default PremisesModules;
